import { callApiPost } from './api';

const logDrtEvent = async (logStatement) => {
    try {
        const response = await callApiPost('/api/v1/drt-log', {
            log_statement: logStatement,
        });
        if (!response.ok) {
            console.error('Failed to log DRT event.');
        }
    } catch (err) {
        console.error('DRT logging error:', err);
    }
};

export default logDrtEvent;
